export class PageBuilderCheckboxPropertiesModel {
  labelText?: string;
  isRequired?: boolean;
  linkText?: string;
  linkUrl?: string;
  labelTextProperties?: {
    fontFamily?: string;
    fontSize?: number;
    color?: string;
  };

  /* eslint-disable @typescript-eslint/no-explicit-any */
  constructor(map: Record<string, any>) {
    this.labelText = map.labelText;
    this.isRequired = map.isRequired;
    this.linkText = map.linkText;
    this.linkUrl = map.linkUrl;
    this.labelTextProperties = map.labelTextProperties;
    /* eslint-enable @typescript-eslint/no-explicit-any */
  }
}